import requests from '../../../../redux/reducer/requests';
import { useDispatch } from 'react-redux';

export default function useTgCallbacks() {
  const dispatch = useDispatch();

  return {
    getTgBonuses: () => dispatch(requests.thunks.getTgBonuses()),
    getTgEnergy: () => dispatch(requests.thunks.getTgEnergy()),
    getTgMoney: () => dispatch(requests.thunks.getTgMoney()),
    getTgTickets: () => dispatch(requests.thunks.getTgTickets()),
    getTgGifts: () => dispatch(requests.thunks.getTgGifts()),
  };
}
